import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Line } from "react-chartjs-2";
import { connect, useSelector } from "react-redux";
import { getSummary } from "../../../actions/marketplace-action";

const EarningsChart = (props)=>{
    const {data,getSummary} = props;
    const {timeframe,selectedExchangeId}=data;
    const {
      earning,
      renters
    } = useSelector((state) => state.marketplace);
    useEffect(() => {
      getSummary(timeframe, selectedExchangeId);
    }, [timeframe, selectedExchangeId]);
    const portfolioValues = earning && earning.map((item) => item.value);
    const graphLabel =
    earning &&
    earning.map((item, index) => {
      return item.time + " UTC";
    });
    let series = [
        {
            name: "Earnings",
            data: portfolioValues
        },
        {
            name: "Renters",
            data: renters
        }
    ]
    let options =  {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false,
          },
        },
        tooltip: {
            fillSeriesColor: true,
            x: {
                show: false,
            }
        },
        colors: ['#07dff7', '#66DA26'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        markers: {
            size: 5,
        },
        legend: {
            show: false,
            labels:{
                colors:"#fff"
            }
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
          xaxis: {
            lines: {
              show: false,
            },
            
          },
          yaxis: {
            lines: {
              show: false,
            }
          },
          padding:{
            left:15
          }
        },
        xaxis: {
          categories: graphLabel,
          labels: {
            style: {
                colors: '#fff',
            },
          },
          tickPlacement: 'between'
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#fff"
            },
            labels: {
              style: {
                colors: "#fff"
              },
              formatter: (value) => { return value.toFixed(0) },
            },
            min:portfolioValues && Math.min(...portfolioValues),
            max:portfolioValues && Math.max(...portfolioValues)
          },
          {
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#fff"
            },
            labels: {
              style: {
                colors: "#fff"
              },
              formatter: (value) => { return value.toFixed(0) },
            },
            min:renters && Math.min(...renters),
            max:renters && Math.max(...renters)
            
          }
        ]
      }
    return(
        <div id="chart">
            <ReactApexChart options={options} series={series} type="line" height={380} />
        </div>
    )
}

export default connect(null,{getSummary}) (EarningsChart)